import React from "react";
import {
  Box, Stack, Typography, FormControl, InputLabel, Select, MenuItem, Button, AppBar, Toolbar, TextField, Container, CssBaseline
} from "@mui/material";
import { SetMeal } from "@mui/icons-material";
import { useAuth } from "../../../hooks/auth";

export const SetUp = () => {
  const {setupmeal} = useAuth();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    setupmeal({
      fullname: data.get('fullname'),
      foodname: data.get('foodname'),
      mealtype: data.get('mealtype'),
    });
  };

  return (
    <Box>
      <AppBar position="sticky">
        <Toolbar disableGutters={true}>
          <Stack
            direction="row"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "white",
            }}
          >
            <SetMeal
              sx={{ margin: "5px", marginLeft: "10px", marginRight: "10px" }}
            />
            <Typography variant="h5">Set Up Today's Meal</Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box sx={{ m: 1 }}>
          <img src='/images/select_icon.svg' alt='Login SVG' height='130px'/>
          </Box>
          <Typography component="p" variant="subtitle1">
            Fill in the details below to proceed
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="fullname"
              label="Enter Full Name"
              name="fullname"
              autoComplete="fullname"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="foodname"
              label="Enter Name of Food"
              id="foodname"
              autoComplete="foodname"
            />
            <FormControl sx={{ minWidth: '100%' }} margin="normal">
              <InputLabel id="demo-simple-select-helper-label">
                Choose Meal Type:
              </InputLabel>
              <Select
                labelId="mealtype-select"
                id="mealtype"
                name="mealtype"
                // value={mealType}
                label="Choose Meal Type"
                // onChange={handleChange}
                autoWidth
              >
                <MenuItem value={"Breakfast"}>Breakfast</MenuItem>
                <MenuItem value={"Lunch"}>Lunch</MenuItem>
                <MenuItem value={"Dinner"}>Dinner</MenuItem>
              </Select>
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, backgroundColor: 'primary.main', color:'white' }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
